import { useQuery } from '@apollo/client';
import { GET_TEMPLATE, Template, TemplateData, TemplateVars } from 'graphql/TemplateQueries';
import React, { useEffect, useState } from 'react'

const useTemplate = ({id}: TemplateVars) => {
  const { loading, error, data } = useQuery<TemplateData, TemplateVars>(GET_TEMPLATE, { variables: {id}});
    const [template, setTemplate] = useState<Template>()
  
    useEffect(() => {
      if(!data)
        return
  
      const newTemplate: Template = structuredClone(data.template)
  
      setTemplate(newTemplate)
    }, [data])
  
    return { loading, error, template }
}

export default useTemplate